import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import type { RootState } from "../store/store";
import { LOGINPAGE } from "../views/auth/routes";
import { isDpOrAdminFromToken } from "../utils/authToken";
import { isTokenValid } from "../utils/isTokenValid";
import { staffHomeFromToken } from "../utils/staffHome";
import PendingRegistrationsNotice from "../views/dp/components/PendingRegistrationsNotice";

type Props = {
  children: React.ReactElement;
  /** O aviso de pendências de cadastro fica fora da ficha da loja, que não é tela do DP. */
  pendingNotice?: boolean;
};

/**
 * Rotas do módulo de Departamento Pessoal: `ADMIN` ou `DP`.
 *
 * Sem token válido, vai para o login. Com token de outro papel, vai para a home
 * DAQUELE papel — não para o login: não é sessão inválida, é falta de permissão,
 * e cair no login faria parecer que a sessão expirou. Mandar um supervisor para
 * `HOMEPAGE` também não serve, porque o `AdminRoute` de lá o devolveria ao login.
 */
const DpRoute: React.FC<Props> = ({ children, pendingNotice = true }) => {
  const rehydrated = useSelector((s: RootState) => !!(s as any)._persist?.rehydrated);
  const token = useSelector((s: RootState) => (s as any).auth?.accessToken);

  if (!rehydrated) return null;

  if (!isTokenValid(token)) {
    return <Navigate to={LOGINPAGE()} replace />;
  }

  if (!isDpOrAdminFromToken(token)) {
    return <Navigate to={staffHomeFromToken(token)} replace />;
  }

  if (!pendingNotice) return children;

  // Aviso "Cadastros com pendência": fixo no topo de todas as telas do DP.
  return (
    <>
      <PendingRegistrationsNotice />
      {children}
    </>
  );
};

export default DpRoute;
